import InputField from '@/components/common/fields/InputField'
import { useState } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { Button } from '@mui/material'
import { HelperTextExtended } from '../HelperTextExtended'
import { useField } from 'formik'

interface PasswordInputProps {
  autoComplete?: string
  label?: string
  name: string
  hideError?: boolean
  hideErrorEmpty?: boolean
  required?: boolean
  error?: string[]
  notes?: string
  customError?: string
}

const eyeIconStyle = {
  position: 'absolute',
  right: '-0.5rem',
  top: '2rem',
  color: '#7c868d',
}

export default function PasswordInput(props: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false)
  const { error, notes, customError, hideError, ...rest } = props
  const [field, meta, helpers] = useField(rest)

  return (
    <div style={{ position: 'relative' }}>
      <InputField
        type={showPassword ? 'text' : 'password'}
        style={{ position: 'relative' }}
        error={error && error?.length > 0}
        hideError={hideError}
        hideErrorEmpty={true}
        {...rest}
      />
      <HelperTextExtended
        hasError={(error && error?.length > 0) || meta.error?.length > 0}
      >
        {notes}
      </HelperTextExtended>
      {showPassword ? (
        <Button
          sx={eyeIconStyle}
          endIcon={<VisibilityOffIcon />}
          onClick={() => setShowPassword(false)}
        />
      ) : (
        <Button
          sx={eyeIconStyle}
          endIcon={<VisibilityIcon />}
          onClick={() => setShowPassword(true)}
        />
      )}
    </div>
  )
}
